import { REWARDS_WIDGET_NAMES } from "@/constants/widget-names";
import {
    RewardsWaysToSpendB2bPageWidgetModalDefinition,
    RewardsWaysToSpendPageWidgetModalDefinition,
} from "@apps/rewards/constants/definitions";
import type { RewardsWidgetInjectorConfig } from "@apps/rewards/types";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";

import RewardsWaysToSpendB2bPageWidgetModal from "./b2b/RewardsWaysToSpendB2bPageWidgetModal";
import RewardsWaysToSpendPageWidgetModal from "./RewardsWaysToSpendPageWidgetModal";

interface RewardsWaysToSpendPageWidgetModalInjectorConfig
    extends RewardsWidgetInjectorConfig {
    isCustomerB2b: boolean;
}

class RewardsWaysToSpendPageWidgetModalInjector {
    constructor(
        private readonly config: RewardsWaysToSpendPageWidgetModalInjectorConfig
    ) {}

    start(): void {
        this.config.logger.debug(
            "RewardsWaysToSpendPageWidgetModalInjector start",
            {
                placeholderSelector: this.config.placeholderSelector,
            }
        );

        const targets$ = this.config.mutationObserverInjector.register({
            targetSelector: this.config.placeholderSelector,
        });

        targets$.subscribe((placeholder) => {
            this.config.logger?.debug(
                "RewardsWaysToSpendPageWidgetModalInjector found placeholder",
                {
                    placeholder,
                }
            );

            let widget:
                | RewardsWaysToSpendPageWidgetModal
                | RewardsWaysToSpendB2bPageWidgetModal;
            let widgetName: REWARDS_WIDGET_NAMES;

            void (async () => {
                if (this.config.isCustomerB2b) {
                    const RewardsWaysToSpendB2bPageWidgetModal =
                        await this.config.dynamicImportManager.importDefault(
                            RewardsWaysToSpendB2bPageWidgetModalDefinition
                        );

                    widgetName =
                        REWARDS_WIDGET_NAMES.REWARDS_WAYS_TO_SPEND_B2B_PAGE_WIDGET_MODAL;

                    widget = new RewardsWaysToSpendB2bPageWidgetModal(
                        {
                            target: placeholder,
                        },
                        this.config.logger
                    );
                } else {
                    const RewardsWaysToSpendPageWidgetModal =
                        await this.config.dynamicImportManager.importDefault(
                            RewardsWaysToSpendPageWidgetModalDefinition
                        );

                    widgetName =
                        REWARDS_WIDGET_NAMES.REWARDS_WAYS_TO_SPEND_PAGE_WIDGET_MODAL;

                    widget = new RewardsWaysToSpendPageWidgetModal(
                        {
                            target: placeholder,
                        },
                        this.config.logger
                    );
                }

                await widget.init();

                this.config.eventsCollector.pushEvent(
                    this.config.eventsFactory.createWidgetInjected(widgetName)
                );

                dispatchSdkEvent(new WidgetInjectedSdkEvent(widgetName));
            })();
        });
    }
}

export default RewardsWaysToSpendPageWidgetModalInjector;
